// Klaviyo form submission handler
function handleKlaviyoFormSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);
    const alertContainer = document.getElementById('alert-container');

    fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            alertContainer.innerHTML = '<div class="alert alert-success" role="alert">Thank you for subscribing!</div>';
            form.reset();
        } else {
            alertContainer.innerHTML = '<div class="alert alert-danger" role="alert">There was an error. Please try again.</div>';
        }
    })
    .catch(error => {
        console.error('Error:', error);
        alertContainer.innerHTML = '<div class="alert alert-danger" role="alert">There was an error. Please try again.</div>';
    });
}

// Main 'Add to cart' (ATC) form
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    // Validate customizer inputs - check for whitespace-only content
    const customizerInputs = form.querySelectorAll('.customizer-input')
    let validationFailed = false
    
    customizerInputs.forEach(input => {
        if (input.hasAttribute('required')) {
            const value = input.value.trim()
            
            // Remove any existing error styling
            input.classList.remove('is-invalid')
            
            if (value === '') {
                input.classList.add('is-invalid')
                validationFailed = true
                
                // Show validation message
                let errorMsg = input.parentElement.querySelector('.invalid-feedback')
                if (!errorMsg) {
                    errorMsg = document.createElement('div')
                    errorMsg.className = 'invalid-feedback'
                    input.parentElement.appendChild(errorMsg)
                }
                errorMsg.textContent = 'This field is required and cannot be empty or contain only spaces.'
            }
        }
    })
    
    // Also validate other required inputs for consistency
    const otherRequiredInputs = form.querySelectorAll('input[required]:not(.customizer-input)')
    otherRequiredInputs.forEach(input => {
        if (input.type === 'text') {
            const value = input.value.trim()
            
            // Remove any existing error styling
            input.classList.remove('is-invalid')
            
            if (value === '') {
                input.classList.add('is-invalid')
                validationFailed = true
                
                // Show validation message
                let errorMsg = input.parentElement.querySelector('.invalid-feedback')
                if (!errorMsg) {
                    errorMsg = document.createElement('div')
                    errorMsg.className = 'invalid-feedback'
                    input.parentElement.appendChild(errorMsg)
                }
                errorMsg.textContent = 'This field is required and cannot be empty or contain only spaces.'
            }
        }
    })
    
    if (validationFailed) {
        return // Stop form submission
    }

    const btn = form.querySelector('.btn-atc')

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    form.classList.add('loading')

    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    form.classList.remove('loading')
    btn.innerHTML = window.theme.product.addedToCart

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textAddToCart
    }, 2000)

    window.refreshCartContents(response)

    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
}

// Product options selector - Listen for change events
window.onChangeProductOption = async (input) => {
    const selectedOptions = []

    input.closest('form').querySelectorAll('.product-option').forEach(elem => {
        if (elem.type === 'radio') {
            if (elem.checked) {
                selectedOptions.push(elem.value)
            }
        } else {
            selectedOptions.push(elem.value)
        }
    })

    const selectedVariant = window.productVariants.find(variant =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    console.log(selectedVariant)

    const btn = input.closest('form').querySelector('.btn-atc');
    const outOfStockForm = document.querySelector('.outOfStockForm');
    const outOfStockP = document.querySelector('.outOfStockP');
    //const outOfStockMessage = "<span class='text-secondary-dark-blue small'><strong>"+ selectedVariant.name +"</strong> <em>is out of stock.</em></span><br>Select a different color or get notified when it's back in stock."
    const hiddenOutOfStockInput = document.querySelector('input[name="product"]');
    const atcDiv = document.querySelector('.atc-div');

    if (selectedVariant) {
        input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            btn.disabled = false
            btn.innerHTML = window.theme.product.addToCart
            outOfStockForm.classList.add('d-none')
            atcDiv.classList.remove('d-none')
            outOfStockP.innerHTML = ''
            hiddenOutOfStockInput.value = ''
        } else {
            btn.disabled = true
            btn.innerHTML = window.theme.product.soldOut
            outOfStockForm.classList.remove('d-none')
            atcDiv.classList.add('d-none')
            //outOfStockP.innerHTML = outOfStockMessage
            hiddenOutOfStockInput.value = selectedVariant.name

            // Add event listener for Klaviyo form submission
            const klaviyoForm = document.getElementById('klaviyo-form');
            if (klaviyoForm && !klaviyoForm.dataset.listenerAdded) {
                klaviyoForm.addEventListener('submit', handleKlaviyoFormSubmit);
                klaviyoForm.dataset.listenerAdded = 'true';
            }
        }

        if (selectedVariant.compare_at_price) {
            input.closest('#product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-compare text-muted me-3">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(selectedVariant.compare_at_price)}
                    </s>
                </span>
                <span class="product-price-final">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(selectedVariant.price)}
                </span>
            `
        } else {
            input.closest('#product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-final">
                    ${Shopify.formatMoney(selectedVariant.price)}
                </span>
            `
        }
        if (selectedVariant.available && selectedVariant.compare_at_price) {
            input.closest('#product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
                <span class="price-badge-sale badge">
                    ${window.theme.product.save}: ${Math.round((1 - (selectedVariant.price / selectedVariant.compare_at_price)) * 100)}%
                </span>    
            `)
        } else if (!selectedVariant.available) {
            input.closest('#product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
                <span class="price-badge-sold-out badge">
                    ${window.theme.product.soldOut}
                </span>
            `)
        }

        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)

        const customEvent = new CustomEvent('variantChange.sd.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        btn.disabled = true
        btn.innerHTML = window.theme.product.unavailable
    }
}

// Handles the onchange event for select dropdowns
function onDropdownChange(selectElement) {
    const selectedValue = selectElement.value

    // Get the corresponding radio button and check it
    const correspondingRadioButton = document.querySelector(`input[type='radio'][id='${selectedValue}Radio']`)
    if (correspondingRadioButton) {
        correspondingRadioButton.checked = true
        // Trigger the change event on the radio button to update the Bootstrap styling
        correspondingRadioButton.dispatchEvent(new Event('change'))
    }

    // Call your existing function
    onChangeProductOption(selectElement)
}

// Add onchange event listener to radio buttons to update select dropdowns when radio buttons are clicked
document.querySelectorAll("input[type='radio']").forEach(radioButton => {
    radioButton.addEventListener('change', (event) => {
        if (event.target.checked) {
            const correspondingSelectOption = document.querySelector(`select option[value='${event.target.id.replace('Radio', '')}']`)
            if (correspondingSelectOption) {
                correspondingSelectOption.selected = true
            }

            // Call your existing function with the corresponding select dropdown
            const correspondingSelectDropdown = document.querySelector(`#product-option-${event.target.name}Select`)
            if (correspondingSelectDropdown) {
                onChangeProductOption(correspondingSelectDropdown)
            }
        }
    })
})

// Add onchange event listeners to select dropdowns to update radio buttons when dropdown value changes
document.querySelectorAll('select.product-option').forEach(selectDropdown => {
    selectDropdown.addEventListener('change', (event) => {
        onDropdownChange(event.target)
    })
})

// Function to simulate a change event
function triggerChangeEvent(element) {
    const event = new Event('change')
    element.dispatchEvent(event)
}

// Get all the dropdowns
const dropdowns = document.querySelectorAll('select.product-option')
// Add the change event listeners
dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('change', function(event) {
        onDropdownChange(event.target)
    })
})

// New code to select the first variant on page load...
const firstDropdown = dropdowns[0]
if (firstDropdown) {
    // Set the first option as selected
    firstDropdown.selectedIndex = 0

    // Trigger a change event to update everything
    triggerChangeEvent(firstDropdown)
}


// Function to get available colors for a specific package
function getAvailableColorsForPackage(package) {
    return window.productVariants
        .filter(variant => variant.options[0] === package)
        .map(variant => variant.options[1]);
}

// Function to get the first available variant for a package
function getFirstAvailableVariantForPackage(package) {
    return window.productVariants.find(variant =>
        variant.options[0] === package && variant.available
    ) || window.productVariants.find(variant =>
        variant.options[0] === package
    );
}

// Function to update color options visibility and selection
function updateColorOptionsForPackage(package) {
    const availableColors = getAvailableColorsForPackage(package);

    // Get all color radio buttons and their labels
    const colorButtons = document.querySelectorAll('input[type="radio"][name="color"]');

    colorButtons.forEach(radio => {
        const colorName = radio.id.replace('Radio', '');
        const isAvailable = availableColors.includes(colorName);
        const label = document.querySelector(`label[for="${radio.id}"]`);

        if (isAvailable) {
            // Show both the radio and its label
            radio.style.display = '';
            if (label) {
                // Check if the label has the rounded-circle class (single color)
                if (label.classList.contains('rounded-circle')) {
                    label.closest('.btn').style.display = '';
                } else {
                    label.style.display = '';
                }
            }
        } else {
            // Hide both the radio and its label
            radio.style.display = 'none';
            if (radio.checked) {
                radio.checked = false;
            }
            if (label) {
                // Check if the label has the rounded-circle class (single color)
                if (label.classList.contains('rounded-circle')) {
                    label.closest('.btn').style.display = 'none';
                } else {
                    label.style.display = 'none';
                }
            }
        }
    });

    // Select the first available color
    const firstVariant = getFirstAvailableVariantForPackage(package);
    if (firstVariant) {
        const colorToSelect = firstVariant.options[1];
        const radioToSelect = document.querySelector(`input[type="radio"][id="${colorToSelect}Radio"]`);
        if (radioToSelect) {
            radioToSelect.checked = true;
        }

        // Update the hidden select
        const colorSelect = document.querySelector('#product-option-colorSelect');
        if (colorSelect) {
            colorSelect.value = colorToSelect;
        }

        // Trigger the variant change
        onChangeProductOption(colorSelect || radioToSelect);
    }
}

// Enhanced package change handler
function onPackageChange(packageInput) {
    const selectedPackage = packageInput.id.replace('Radio', '');

    // Update the package select if it exists
    const packageSelect = document.querySelector('#product-option-packageSelect');
    if (packageSelect) {
        packageSelect.value = selectedPackage;
    }

    // Make sure package options stay visible
    document.querySelectorAll('input[type="radio"][name="package"]').forEach(radio => {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
            label.style.display = '';
        }
    });

    // Update color options and trigger selection
    updateColorOptionsForPackage(selectedPackage);
}
// Initialize the product options on page load
function initializeProductOptions() {
    if (!window.productVariants) {
        return;
    }
    // Get the package options if they exist
    const packageRadios = document.querySelectorAll('input[type="radio"][name="package"]');
    const firstPackageRadio = packageRadios[0];

    if (firstPackageRadio) {
        // If we have package options, select the first one and update colors
        firstPackageRadio.checked = true;
        onPackageChange(firstPackageRadio);
    } else {
        // If we only have colors, select the first available one
        const firstColorVariant = window.productVariants.find(variant => variant.available) || window.productVariants[0];
        if (firstColorVariant) {
            const colorToSelect = firstColorVariant.options[0];
            const radioToSelect = document.querySelector(`input[type="radio"][id="${colorToSelect}Radio"]`);
            if (radioToSelect) {
                radioToSelect.checked = true;
                onChangeProductOption(radioToSelect);
            }
        }
    }
}

function initializeProductPage() {
    // Check if we're on a product page
    if (!window.productVariants) {
        return; // Exit if not on a product page
    }

    // Add event listeners for package radio buttons
    document.querySelectorAll('input[type="radio"][name="package"]').forEach(radio => {
        radio.addEventListener('change', (event) => {
            if (event.target.checked) {
                onPackageChange(event.target);
            }
        });
    });

    // Initialize product options when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeProductOptions);
    } else {
        initializeProductOptions(); // If DOM is already loaded
    }
}

// Call the initialization
initializeProductPage();

// Add event listeners for package radio buttons
document.querySelectorAll('input[type="radio"][name="package"]').forEach(radio => {
    radio.addEventListener('change', (event) => {
        if (event.target.checked) {
            onPackageChange(event.target);
        }
    });
});

// Call initialization when DOM is ready
document.addEventListener('DOMContentLoaded', initializeProductOptions);

// Real-time validation for customizer inputs
document.addEventListener('DOMContentLoaded', () => {
    const customizerInputs = document.querySelectorAll('.customizer-input')
    const otherRequiredTextInputs = document.querySelectorAll('input[required][type="text"]:not(.customizer-input)')
    
    // Combine both sets of inputs for unified validation
    const allInputsToValidate = [...customizerInputs, ...otherRequiredTextInputs]
    
    allInputsToValidate.forEach(input => {
        if (input.hasAttribute('required')) {
            // Validate on input (as user types)
            input.addEventListener('input', (e) => {
                validateSingleInput(e.target)
            })
            
            // Also validate on blur (when user leaves the field)
            input.addEventListener('blur', (e) => {
                validateSingleInput(e.target)
            })
        }
    })
})

// Helper function to validate a single input
function validateSingleInput(input) {
    const value = input.value.trim()
    
    // Remove any existing error styling
    input.classList.remove('is-invalid')
    
    // Remove existing error message
    const existingErrorMsg = input.parentElement.querySelector('.invalid-feedback')
    if (existingErrorMsg) {
        existingErrorMsg.remove()
    }
    
    if (input.hasAttribute('required') && value === '') {
        input.classList.add('is-invalid')
        
        // Show validation message
        const errorMsg = document.createElement('div')
        errorMsg.className = 'invalid-feedback'
        errorMsg.textContent = 'This field is required and cannot be empty or contain only spaces.'
        input.parentElement.appendChild(errorMsg)
        
        return false
    }
    
    return true
}



// Product Gallery
const initProductGallery = () => {
    const wrapper = document.querySelector('#product-gallery')

    if (!wrapper) return

    window.addEventListener('variantChange.sd.product', (event) => {
        const selectedVariant = event.detail

        if (selectedVariant.featured_media) {
            bootstrap.Carousel.getOrCreateInstance('#product-gallery').to(selectedVariant.featured_media.position - 1)
        }
    }, false)

    if (window.matchMedia('(min-width: 992px)').matches) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
        wrapper.style.position = 'sticky'
        wrapper.style.top = `${navbarHeight + 20}px`
        wrapper.style.zIndex = '1'
    }
}
initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#product-gallery')) {
        initProductGallery()
    }
})

// 'Buy it now' button
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]').value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}

// Add this at the end of your JavaScript file
document.addEventListener('DOMContentLoaded', () => {
    const klaviyoForm = document.getElementById('klaviyo-form');
    if (klaviyoForm && !klaviyoForm.dataset.listenerAdded) {
        klaviyoForm.addEventListener('submit', handleKlaviyoFormSubmit);
        klaviyoForm.dataset.listenerAdded = 'true';
    }
});
